import { guardUnspecified } from '@portal/utils/util-guards';
import { componentFactory } from 'vue-tsx-support';

import { SendOpinionBlock, tsStoreMixin } from '@jtnews/shared';
import { OPINION_RULE_LINK } from '@jtnews/shared/data';

export default componentFactory.mixin(tsStoreMixin).create({
  name: 'BecomeAnAuthor',
  computed: {
    isUserAuth(): boolean {
      return guardUnspecified(this.store.commonModule?.userInfo);
    }
  },
  methods: {
    showShareOpinionBlock() {
      this.sendShareOpinionReachGoal('Просмотр', 'viewShareOpinionContent');
    },
    clickShareOpinionLink() {
      this.sendShareOpinionReachGoal('Клик Как это сделать', 'howtoShareOpinionContent');
    },
    sendShareOpinionReachGoal(valueName: string, goalName: string) {
      const blockType = 'Контент';
      const fieldType = 'Поделиться Мнением';

      this.store.analyticsModule.sendNewReachGoal({
        blockType,
        fieldType,
        valueName,
        goalName
      });
    }
  },
  render() {
    return (
      <SendOpinionBlock
        isUserAuth={this.isUserAuth}
        reachGoalBlockType="Контент"
        onShowed={() => this.showShareOpinionBlock()}
      >
        <p>
          <b>Станьте автором колонки.</b>
        </p>
        <p>
          <a href={OPINION_RULE_LINK} onClick={() => this.clickShareOpinionLink()}>
            {`Почитайте рекомендации `}
          </a>
          и напишите нам!
        </p>
      </SendOpinionBlock>
    );
  }
});
